<template>
  <div class="page-comp-call-log">
    <special-head :title="$t('通话记录')" />

    <jw-spin v-if="loading" :tip="$t('数据加载中') + '……'" class="spin-loading"> </jw-spin>

    <template v-if="systemInfo?.length != 0">
      <div class="call-log-item-list">
        <div class="call-log-item" v-for="item in systemInfo" :key="item.detailId">
          <special-card>
            <template #title>
              <div class="call-log-title-wrap">
                <span class="call-log-item-title">{{ item?.calleeName || '-' }}</span
                >|
                <span class="call-log-item-title">{{ item?.callee || '-' }}</span>
              </div>
            </template>
            <template #more>
              <div class="call-log-item-more">
                <xl-dot :style="{ marginLeft: '15px' }" :color="item.link === 'true' ? '#37b41a' : 'orange'" :title="item.link === 'true' ? $t('已接通') : $t('未接通')"></xl-dot>

                <template v-if="item.link === 'true' && [1, 2, 3].includes(type) && userStore.userInfo?.roles?.includes(`${permissionPrefix}:addFollow`) && buttons.includes(`${permissionPrefix}:addFollow`)">
                  <span v-if="item?.recordId" :style="{ color: 'var(--color-text-3)' }">{{ $t('已添加动态记录') }}</span>
                  <jw-dropdown v-else>
                    <jw-button type="text" size="small" class="handle-btn-more"><qfei-icon-more-applications-outlined /></jw-button>
                    <template #content>
                      <jw-doption @click="addCall(item)">{{ $t('添加动态记录') }}</jw-doption>
                    </template>
                  </jw-dropdown>
                </template>
              </div>
            </template>

            <div class="call-log-item-content">
              <div class="call-log-item-content-item">
                <div class="call-log-item-content-item-title">{{ $t('拨打时间') }}</div>
                <div class="call-log-item-content-item-value">{{ item?.startTime || '-' }}</div>
              </div>

              <div class="call-log-item-content-item">
                <div class="call-log-item-content-item-title">{{ $t('应答时间') }}</div>
                <div class="call-log-item-content-item-value">{{ item?.answerTime || '-' }}</div>
              </div>
              <div class="call-log-item-content-item">
                <div class="call-log-item-content-item-title">{{ $t('结束时间') }}</div>
                <div class="call-log-item-content-item-value">{{ item?.endTime || '-' }}</div>
              </div>
              <div class="call-log-item-content-item">
                <div class="call-log-item-content-item-title">{{ $t('通话时长') }}</div>
                <div class="call-log-item-content-item-value">{{ item?.timeLong || '-' }}</div>
              </div>
              <div class="call-log-item-content-item">
                <div class="call-log-item-content-item-title">{{ $t('拨打人') }}</div>
                <div class="call-log-item-content-item-value">{{ item?.userName || '-' }}</div>
              </div>
              <div class="call-log-item-content-item">
                <div class="call-log-item-content-item-title">{{ $t('录音文件') }}</div>
                <div class="call-log-item-content-item-value">
                  <jw-link class="call-log-item-content-item-value-link" v-if="item?.videoUrl" @click.prevent="useUrlAddUser(item)">{{ $t('查看详情') }}</jw-link>
                  <template v-else>-</template>
                </div>
              </div>
            </div>
          </special-card>
        </div>
      </div>
    </template>
    <template v-else>
      <jw-empty v-if="!loading" class="eltimeline" :img-src="imgSvg"> {{ $t('暂无通话记录') }} </jw-empty>
    </template>
    <!-- 添加/编辑动态记录 -->
    <xl-update-records ref="updaterecordsRef" @cb="getCallList"></xl-update-records>
  </div>
</template>
<script>
import { reactive, toRefs, ref, inject, onMounted, computed } from 'vue';
import useUrlAddUser from '@/hooks/video-add-user';
import imgSvg from '@/assets/images/img-no-record.svg';
import { layoutService } from '@/api/';
import useLoading from '@/hooks/loading';
import { useCalllogStore, useUserStore } from '@/store';
import { useI18n } from 'vue-i18n';
import SpecialHead from '@/components/fh-detail/components/special-head/index.vue';
import SpecialCard from '@/components/fh-detail/components/special-card/index.vue';
export default {
  name: 'XlCalllog',
  components: {
    SpecialHead,
    SpecialCard
  },
  props: {
    moduleId: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { t } = useI18n();
    const { loading, setLoading } = useLoading(true);
    const useCalllog = useCalllogStore(); //通话记录
    const updaterecordsRef = ref(); //动态记录
    const userStore = useUserStore();
    const data = reactive({
      systemInfo: [],
      id: inject('detailParams').id,
      type: inject('detailParams').entity,
      hasEdit: inject('detailParams')?.hasEdit,
      permission: inject('detailParams')?.permission //权限
    });

    // 权限前缀
    const permissionPrefix = computed(() => {
      const map = {
        1: 'clue',
        2: 'customer',
        3: 'businessOpportunity'
      };
      return map[data.type] || '';
    });

    // 添加动态记录
    const addCall = (record) => {
      const params = {
        followTitle: t('添加跟进'),
        isUpdate: true, //是否刷新动态记录列表 true
        ...record,
        sourceType: 'calllog' // 入口来源 通话记录
      };
      updaterecordsRef.value.updateRecordShow(params);
    };
    // 获取通话记录
    const getCallList = () => {
      setLoading(true);
      data.systemInfo = [];
      const params = {
        id: data.id,
        type: data.type
      };
      useCalllog
        .getOutCallDetail(params)
        .then((res) => {
          console.log(res);
          data.systemInfo = res?.result;
        })
        .finally(() => {
          setLoading(false);
        });
    };
    onMounted(() => {
      getCallList();
      getDetail();
    });
    const buttons = ref([]);
    const getDetail = async () => {
      if (!props?.moduleId) {
        return false;
      }
      try {
        const params = {
          entity: data.type,
          moduleId: props.moduleId,
          businessId: data.id
        };
        const json = await layoutService.getDetail(params);
        if (!json.error) {
          const _buttons = [];
          json?.result?.map((b) => {
            _buttons.push(b.value);
          });
          buttons.value = _buttons;
        }
      } catch (e) {
        console.log(e);
      }
    };
    return {
      addCall,
      getCallList,
      useUrlAddUser,
      loading,
      imgSvg,
      useCalllog,
      updaterecordsRef,
      userStore,
      buttons,
      permissionPrefix,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-calllog.less';
</style>
